// This file is auto-generated by @hey-api/openapi-ts

export const $UpdateNutzerDto = {
    required: ['anrede', 'email', 'idpId', 'nachname', 'vorname'],
    type: 'object',
    properties: {
        idpId: {
            maxLength: 36,
            minLength: 0,
            type: 'string',
            description: 'IdP ID of the user',
            example: '550e8400-e29b-41d4-a716-446655440000',
        },
        anrede: {
            pattern: '^(Herr|Frau|Divers)$',
            type: 'string',
            description: 'Anrede of the user',
            example: 'Herr',
        },
        titel: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Titel of the user',
            example: 'Professor',
        },
        vorname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Vorname of the user',
            example: 'Max',
        },
        nachname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Nachname of the user',
            example: 'Mustermann',
        },
        email: {
            maxLength: 128,
            minLength: 0,
            type: 'string',
            description: 'E-Mail of the user',
            example: 'Max.Mustermann@formular-demo.de',
        },
        telefon: {
            pattern: '^+[1-9]d{6,18}$',
            type: 'string',
            description: 'Telefon of the user',
            example: '+492214710543',
        },
    },
} as const;

export const $NutzerDto = {
    required: ['anrede', 'email', 'idpId', 'nachname', 'rollen', 'vorname'],
    type: 'object',
    properties: {
        idpId: {
            maxLength: 36,
            minLength: 0,
            type: 'string',
            description: 'IdP ID of the user',
            example: '550e8400-e29b-41d4-a716-446655440000',
        },
        anrede: {
            pattern: '^(Herr|Frau|Divers)$',
            type: 'string',
            description: 'Anrede of the user',
            example: 'HERR',
        },
        titel: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Titel of the user',
            example: 'Professor',
        },
        vorname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Vorname of the user',
            example: 'Max',
        },
        nachname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Nachname of the user',
            example: 'Mustermann',
        },
        email: {
            maxLength: 128,
            minLength: 0,
            type: 'string',
            description: 'E-Mail of the user',
            example: 'Max.Mustermann@formular-demo.de',
        },
        telefon: {
            pattern: '^+[1-9]d{6,18}$',
            type: 'string',
            description: 'Telefon of the user',
            example: '+492214710543',
        },
        rollen: {
            maxItems: 1,
            minItems: 1,
            type: 'array',
            items: {
                type: 'string',
                description: 'Rollen of the user',
                example: 'COMPANY_USER',
                enum: ['FFA_ADMIN', 'FFA_USER', 'COMPANY_USER'],
            },
        },
        emailVerifiziert: {
            type: 'boolean',
            description: 'Whether the e-mail was verified',
            example: true,
        },
    },
} as const;

export const $UpdateUnternehmenszuordnungDto = {
    required: ['aktiv', 'nutzerIdpId', 'rolle'],
    type: 'object',
    properties: {
        nutzerIdpId: {
            maxLength: 36,
            minLength: 0,
            type: 'string',
            description: 'IdP ID of the user',
            example: '550e8400-e29b-41d4-a716-446655440000',
        },
        rolle: {
            type: 'string',
            description: 'Rolle of the user for the unternehmen',
            example: 'UNTERNEHMEN_MITARBEITER',
            enum: ['UNTERNEHMEN_MITARBEITER', 'UNTERNEHMEN_ADMIN', 'FFA_MITARBEITER', 'FFA_ADMIN'],
        },
        aktiv: {
            type: 'boolean',
            description: 'Whether the unternehmenszuordnung is currently active',
            example: true,
        },
    },
} as const;

export const $UnternehmenszuordnungDto = {
    required: ['aktiv', 'ffaUnternehmen', 'nutzerIdpId', 'rolle', 'unternehmenAktiv', 'unternehmenId', 'unternehmenName'],
    type: 'object',
    properties: {
        nutzerIdpId: {
            maxLength: 36,
            minLength: 0,
            type: 'string',
            description: 'IdP ID of the user',
            example: '550e8400-e29b-41d4-a716-446655440000',
        },
        unternehmenId: {
            type: 'integer',
            description: 'ID of the unternehmen',
            format: 'int64',
            example: 1,
        },
        unternehmenName: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Name of the unternehmen',
            example: 'Testunternehmen',
        },
        unternehmenAktiv: {
            type: 'boolean',
            description: 'Whether the unternehmen is currently active',
            example: true,
        },
        rolle: {
            type: 'string',
            description: 'Rolle of the user for the unternehmen',
            example: 'UNTERNEHMEN_MITARBEITER',
            enum: ['UNTERNEHMEN_MITARBEITER', 'UNTERNEHMEN_ADMIN', 'FFA_MITARBEITER', 'FFA_ADMIN'],
        },
        aktiv: {
            type: 'boolean',
            description: 'Whether the unternehmenszuordnung is currently active',
            example: true,
        },
        ffaUnternehmen: {
            type: 'boolean',
            description: 'Whether the unternehmenszuordnung is a ffa_unternehmen',
            example: true,
        },
    },
} as const;

export const $CreateUnternehmenszuordnungDto = {
    required: ['aktiv', 'email', 'rolle'],
    type: 'object',
    properties: {
        email: {
            maxLength: 128,
            minLength: 0,
            type: 'string',
            description: 'E-Mail of the user',
            example: 'Max.Mustermann@formular-demo.de',
        },
        rolle: {
            type: 'string',
            description: 'Rolle of the user for the unternehmen',
            example: 'UNTERNEHMEN_MITARBEITER',
            enum: ['UNTERNEHMEN_MITARBEITER', 'UNTERNEHMEN_ADMIN', 'FFA_MITARBEITER', 'FFA_ADMIN'],
        },
        aktiv: {
            type: 'boolean',
            description: 'Whether the unternehmenszuordnung is currently active',
            example: true,
        },
    },
} as const;

export const $CreateNutzerDto = {
    required: ['anrede', 'email', 'nachname', 'vorname'],
    type: 'object',
    properties: {
        anrede: {
            pattern: '^(Herr|Frau|Divers)$',
            type: 'string',
            description: 'Anrede of the user',
            example: 'Herr',
        },
        titel: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Titel of the user',
            example: 'Professor',
        },
        vorname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Vorname of the user',
            example: 'Max',
        },
        nachname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Nachname of the user',
            example: 'Mustermann',
        },
        email: {
            maxLength: 128,
            minLength: 0,
            type: 'string',
            description: 'E-Mail of the user',
            example: 'Max.Mustermann@formular-demo.de',
        },
        telefon: {
            pattern: '^+[1-9]d{6,18}$',
            type: 'string',
            description: 'Telefon of the user',
            example: '+492214710543',
        },
    },
} as const;

export const $CreateNebenantragDto = {
    type: 'object',
    properties: {
        nebenantragsartId: {
            type: 'integer',
            description: 'ID of the desired Nebenantragsart',
            format: 'int64',
            example: 1,
        },
        hauptantragId: {
            type: 'integer',
            description: 'ID of the referenced Foerderantrag',
            format: 'int64',
            example: 2,
        },
    },
} as const;

export const $AntragsnummerDto = {
    required: ['antragsnummer', 'id'],
    type: 'object',
    properties: {
        antragsnummer: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Antragsnummer of the Antrag',
            example: 'FFA_272-VVTAS4',
        },
        id: {
            type: 'integer',
            description: 'Id of the Antrag',
            format: 'int64',
            example: 10,
        },
    },
} as const;

export const $CreateBearbeiterDto = {
    required: ['foerderantragIds', 'nutzerIdpId'],
    type: 'object',
    properties: {
        nutzerIdpId: {
            maxLength: 36,
            minLength: 0,
            type: 'string',
            description: 'IdP ID of the user',
            example: '550e8400-e29b-41d4-a716-446655440000',
        },
        foerderantragIds: {
            type: 'array',
            description: 'List of Foerderantrag IDs',
            example: [1, 2, 3],
            items: {
                type: 'integer',
                description: 'List of Foerderantrag IDs',
                format: 'int64',
            },
        },
    },
} as const;

export const $BearbeiterDto = {
    required: ['foerderantragId', 'nutzerIdpId'],
    type: 'object',
    properties: {
        nutzerIdpId: {
            maxLength: 36,
            minLength: 0,
            type: 'string',
            description: 'IdP ID of the user',
            example: '550e8400-e29b-41d4-a716-446655440000',
        },
        foerderantragId: {
            type: 'integer',
            description: 'Id of the Foerderantrag',
            format: 'int64',
            example: 1,
        },
    },
} as const;

export const $ModifyBearbeiterWithMultipleNutzerDto = {
    required: ['foerderantragId', 'nutzerIdpIds'],
    type: 'object',
    properties: {
        foerderantragId: {
            type: 'integer',
            description: 'IdP Id of the user',
            format: 'int64',
        },
        nutzerIdpIds: {
            type: 'array',
            items: {
                type: 'string',
                description: 'Idp Id of the users',
                example: '550e8400-e29b-41d4-a716-446655440000',
            },
        },
    },
} as const;

export const $MaintenanceInputDto = {
    type: 'object',
    properties: {
        start: {
            type: 'string',
            description: 'Start time of the maintenance',
            format: 'date-time',
            example: '2025-01-01T00:00:00Z',
        },
        end: {
            type: 'string',
            description: 'End time of the maintenance',
            format: 'date-time',
            example: '2025-01-01T00:00:00Z',
        },
    },
} as const;

export const $BroadcastNachrichtDto = {
    required: ['messageEnum'],
    type: 'object',
    properties: {
        messageEnum: {
            type: 'string',
            description: 'Message type',
            example: 'DOWNTIMES_ANKUENDIGUNG',
            enum: [
                'NUTZER_BEARBEITER_HINZUGEFUEGT',
                'NUTZER_BEARBEITER_ENTFERNT',
                'NUTZER_BEANTRAGUNGSERLAUBNIS_HINZUGEFUEGT',
                'NUTZER_BEANTRAGUNGSERLAUBNIS_ENTFERNT',
                'NUTZER_HINZUGEFUEGT',
                'NUTZER_ENTFERNT',
                'NUTZER_ADMIN',
                'NUTZER_ANTRAGSTELLER',
                'NUTZER_AKTIV',
                'NUTZER_INAKTIV',
                'DOKUMENTZUSTELLUNG',
                'UNTERNEHMENSREGISTRIERUNG',
                'ERSTREGISTRIERUNG',
                'ANTRAG_EINGEREICHT',
                'ANTRAG_UNTERNEHMENSREGISTRIERUNG_EINGEREICHT',
                'ANTRAG_STAMMDATENAENDERUNG_EINGEREICHT',
                'NEBENANTRAG_EINGEREICHT',
                'ANTRAG_WIDERSPRUCH_EINGEREICHT',
                'ANTRAG_ZURUECKGEZOGEN_EINGEREICHT',
                'STATUS_AENDERUNG',
                'STATUS_DATENNACHFORDERUNG',
                'STATUS_KOMMISSION_DATENNACHREICHUNG',
                'STATUS_STAMMDATENAENDERUNG_BEWILLIGT',
                'STATUS_STAMMDATENAENDERUNG_ABGELEHNT',
                'STATUS_STAMMDATENREGISTRIERUNG_ABGELEHNT',
                'NEUE_DATENSCHUTZBEDINGUNGEN',
                'NEUE_NUTZUNGSBEDINGUNGEN',
                'DOWNTIMES_ANKUENDIGUNG',
                'ALLGEMEINE_BENACHRICHTIGUNG',
            ],
        },
        templateModel: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                description: 'Parameters for message content',
                example: {
                    tag1: 'value1',
                    tag2: 'value2',
                },
            },
            description: 'Parameters for message content',
            example: {
                tag1: 'value1',
                tag2: 'value2',
            },
        },
    },
} as const;

export const $UpdateUnternehmensnameDto = {
    required: ['unternehmensname'],
    type: 'object',
    properties: {
        unternehmensname: {
            type: 'string',
            description: 'The name of the Unternehmen',
            example: 'Test Unternehmen GmbH',
        },
    },
} as const;

export const $ConfirmAbholungDto = {
    required: ['antragIdentifier', 'jsonVersionIdentifier', 'pdfVersionIdentifier', 'xmlVersionIdentifier'],
    type: 'object',
    properties: {
        antragIdentifier: {
            type: 'string',
            description: 'The identifier of the Antrag in CMIS',
        },
        jsonVersionIdentifier: {
            type: 'string',
            description: 'The version identifier of the form JSON object in CMIS',
        },
        pdfVersionIdentifier: {
            type: 'string',
            description: 'The version identifier of the form PDF resource in CMIS',
        },
        xmlVersionIdentifier: {
            type: 'string',
            description: 'The version identifier of the form XML resource in CMIS',
        },
    },
} as const;

export const $NutzerAdminResponseDto = {
    required: ['aktiv', 'anrede', 'email', 'emailVerifiziert', 'idpId', 'nachname', 'rolle', 'vorname'],
    type: 'object',
    properties: {
        idpId: {
            maxLength: 36,
            minLength: 0,
            type: 'string',
            description: 'IdP ID of the user',
            example: '550e8400-e29b-41d4-a716-446655440000',
        },
        anrede: {
            pattern: '^(Herr|Frau|Divers)$',
            type: 'string',
            description: 'Anrede of the user',
            example: 'HERR',
        },
        titel: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Titel of the user',
            example: 'Professor',
        },
        vorname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Vorname of the user',
            example: 'Max',
        },
        nachname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Nachname of the user',
            example: 'Mustermann',
        },
        email: {
            maxLength: 128,
            minLength: 0,
            type: 'string',
            description: 'E-Mail of the user',
            example: 'Max.Mustermann@formular-demo.de',
        },
        telefon: {
            pattern: '^+[1-9]d{6,18}$',
            type: 'string',
            description: 'Telefon of the user',
            example: '+492214710543',
        },
        emailVerifiziert: {
            type: 'boolean',
            description: 'Whether the e-mail was verified',
            example: true,
        },
        rolle: {
            type: 'string',
            description: 'Rolle of the user',
            example: 'UNTERNEHMEN_MITARBEITER',
            enum: ['UNTERNEHMEN_MITARBEITER', 'UNTERNEHMEN_ADMIN', 'FFA_MITARBEITER', 'FFA_ADMIN'],
        },
        aktiv: {
            type: 'boolean',
            description: 'Whether the unternehmenszuordnung is currently active',
            example: true,
        },
    },
} as const;

export const $PaginatedResponseNutzerAdminResponseDto = {
    type: 'object',
    properties: {
        content: {
            type: 'array',
            items: {
                $ref: '#/components/schemas/NutzerAdminResponseDto',
            },
        },
        size: {
            type: 'integer',
            format: 'int32',
        },
        numberOfElements: {
            type: 'integer',
            format: 'int32',
        },
        totalElements: {
            type: 'integer',
            format: 'int64',
        },
        totalPages: {
            type: 'integer',
            format: 'int32',
        },
        empty: {
            type: 'boolean',
        },
    },
} as const;

export const $AdresseDto = {
    required: ['id', 'land'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'ID of the Adresse',
            format: 'int64',
            example: 1,
        },
        land: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of Land of the Adresse',
            example: 'Deutschland',
        },
        bundesland: {
            maxLength: 30,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of Bundesland of the Adresse',
            example: 'Baden-Württemberg',
        },
        plz: {
            maxLength: 5,
            minLength: 0,
            pattern: '^d{5}$',
            type: 'string',
            description: 'PLZ of the Adresse',
            example: '12345',
        },
        ort: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Ort of the Adresse',
            example: 'Berlin',
        },
        strasse: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Strasse of the Adresse',
            example: 'Mühlenstraße',
        },
        hausnummer: {
            maxLength: 20,
            minLength: 0,
            type: 'string',
            description: 'Hausnummer of the Adresse',
            example: '78-80',
        },
        zusatz: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Zusatz of the Adresse',
            example: 'c/o Herr Zimmer',
        },
        anschriftFreitext: {
            maxLength: 500,
            minLength: 0,
            type: 'string',
            description: 'Freitext of the Adresse used for international adress',
            example: `Mr Ex Sample

Finance and Accounting
Australia Post
12–543 Cleveland St
STRAWBERRY HILLS  NSW  1427
`,
        },
    },
    description: 'Adresse of the Unternehmen',
} as const;

export const $GeschaeftsfuehrerDto = {
    required: ['anrede', 'id', 'nachname', 'vorname'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'ID of the Geschaeftsfuehrer',
            format: 'int64',
            example: 1,
        },
        anrede: {
            pattern: '^(Herr|Frau|Divers)$',
            type: 'string',
            description: 'Anrede of the Geschaeftsfuehrer',
            example: 'HERR',
        },
        titel: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Titel of the Geschaeftsfuehrer',
            example: 'Dr.',
        },
        vorname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Vorname of the Geschaeftsfuehrer',
            example: 'Max',
        },
        nachname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Nachname of the Geschaeftsfuehrer',
            example: 'Mustermann',
        },
    },
    description: 'Geschaeftsfuehrer of the Unternehmen',
} as const;

export const $NiederlassungDto = {
    required: ['id', 'name'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'ID of the Niederlassung',
            format: 'int64',
            example: 1,
        },
        name: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Name of the Niederlassung',
            example: 'Metropolis am Ebertplatz',
        },
        adresse: {
            $ref: '#/components/schemas/AdresseDto',
        },
    },
    description: 'Niederlassung of the Unternehmen',
} as const;

export const $UnternehmenWithRelationsDto = {
    required: ['adresse', 'ffaid', 'geschaeftsfuehrer', 'id', 'idOfRegistrationForm', 'rechtsform', 'unternehmensname'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'ID of the Unternehmen',
            format: 'int64',
            example: 1,
        },
        ffaid: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Kunden-ID of the Unternehmen (also known as Kundennummer)',
            example: '345',
        },
        unternehmensname: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Name of the Unternehmen',
            example: 'Metropolis Lichtspieltheater',
        },
        rechtsform: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of Rechtsform of the Unternehmen',
            example: 'Gesellschaft mit beschränkter Haftung (GmbH)',
        },
        andereRechtsform: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Rechtsform of the Unternehmen if it is not included in the selection of Rechtsform',
            example: 'freischaffender Künstler',
        },
        geschaeftsfuehrer: {
            type: 'array',
            items: {
                $ref: '#/components/schemas/GeschaeftsfuehrerDto',
            },
        },
        niederlassungen: {
            type: 'array',
            items: {
                $ref: '#/components/schemas/NiederlassungDto',
            },
        },
        adresse: {
            $ref: '#/components/schemas/AdresseDto',
        },
        homepage: {
            maxLength: 256,
            minLength: 0,
            type: 'string',
            description: 'Homepage of the Unternehmen',
            example: 'http://example.com',
        },
        umsatzsteuerId: {
            maxLength: 20,
            minLength: 0,
            type: 'string',
            description: 'Umsatzsteuer-ID of the Unternehmen',
            example: 'DE567276250',
        },
        kmu: {
            type: 'boolean',
            description: "Whether the Unternehmen is considered as 'Kleine und mittlere Unternehmen'",
            example: false,
        },
        vorsteuerabzugsberechtigt: {
            type: 'boolean',
            description: 'Whether the Unternehmen is vorsteuerabzugsberechtigt',
            example: false,
        },
        steueridentifikationsnummer: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Steueridentifikationsnummer of the Unternehmen',
            example: '4789034782340',
        },
        juristischePerson: {
            type: 'boolean',
            description: 'Whether the Unternehmen is a juristische person',
            example: true,
        },
        dokumentIdForHraOrGewerbeschein: {
            type: 'integer',
            description: 'Dokument Id for the HRA, or Gewerbeschein',
            format: 'int64',
            example: 1,
        },
        dokumentnameForHraOrGewerbeschein: {
            type: 'string',
            description: 'Dokument Name for the HRA, or Gewerbeschein',
            example: 'hra.pdf',
        },
        idOfRegistrationForm: {
            type: 'integer',
            description: 'Id of the registration foederantrag of the unternehmen',
            format: 'int64',
            example: 1,
        },
    },
} as const;

export const $NebenantragsartDto = {
    required: ['bezeichnung', 'gatewayShortname', 'id', 'sortierPosition'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'Id of the Nebenantragsart',
            format: 'int64',
            example: 8,
        },
        gatewayShortname: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Gateway shortname of the Nebenantragsart',
            example: 'aaz',
        },
        bezeichnung: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of the Nebenantragsart',
            example: 'Antrag auf Zuerkennung',
        },
        sortierPosition: {
            type: 'integer',
            description: 'Sortierposition of the Nebenantragsart',
            format: 'int32',
            example: 1000,
        },
    },
} as const;

export const $NebenantragsartCountDto = {
    required: ['amount', 'bezeichnung', 'gatewayShortname', 'id', 'sortierPosition'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'Id of the Nebenantragsart',
            format: 'int64',
            example: 1,
        },
        gatewayShortname: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Gateway shortname of the Nebenantragsart',
            example: 'AzuR',
        },
        bezeichnung: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of the Nebenantragsart',
            example: 'Antrag zum Ratenabruf',
        },
        sortierPosition: {
            type: 'integer',
            description: 'Sortierposition of the Nebenantragsart',
            format: 'int32',
            example: 1000,
        },
        amount: {
            type: 'integer',
            description: 'Number of Nebenantraege with Nebenantragsart for a given Foerderantrag',
            format: 'int64',
            example: 2,
        },
    },
} as const;

export const $NebenantragDto = {
    required: ['aktualisiertAm', 'aktualisiertVon', 'antragsnummer', 'id', 'status'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'Id of the Nebenantrag',
            format: 'int64',
            example: 1,
        },
        antragsnummer: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Antragsnummer of the Nebenantrag',
            example: '1',
        },
        status: {
            type: 'string',
            description: 'Status of the Nebenantrag',
            example: 'ANTRAG_ANGELEGT',
            enum: [
                'ANTRAG_ANGELEGT',
                'ANTRAG_EINGEREICHT',
                'PRUEFUNG',
                'PRUEFUNG_ERNEUT',
                'ANTRAG_ZURUECKGEZOGEN',
                'ANTRAG_DATENNACHFORDERUNG',
                'KOMMISSION',
                'KOMMISSION_DATENNACHREICHUNG',
                'ABLEHNUNG',
                'ZUSAGE_PRUEFUNG',
                'ANTRAG_BEWILLIGT',
                'VERWENDUNGSNACHWEISPRUEFUNG',
                'WIDERSPRUCH',
                'TILGUNG',
                'ABGESCHLOSSEN',
                'DATENUEBERNAHME',
                'DATENUEBERNAHME_ABGESCHLOSSEN',
                'WIRD_EINGEREICHT',
                'ABHOLBEREIT',
                'ABGEHOLT',
                'ANTRAG_GELOESCHT',
            ],
        },
        aktualisiertAm: {
            type: 'string',
            description: 'Date of the last update of the Nebenantrag',
            format: 'date-time',
            example: '2024-04-16T13:08:43.704Z',
        },
        aktualisiertVon: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'E-Mail of Nutzer who did the last update of the Nebenantrag',
            example: 'user1company@formular-demo.de',
        },
        gatewayId: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Gateway Id of the Nebenantrag',
            example: '1235',
        },
        fmsUuid: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'FFMS uuid of the Nebenantrag',
            example: '1136b543-5bf4-49d2-9ed8-aadad4256cd5',
        },
        formularShortname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'formular shortname of the Nebenantrag',
            example: 'FFA_000',
        },
    },
} as const;

export const $PaginatedResponseNebenantragDto = {
    type: 'object',
    properties: {
        content: {
            type: 'array',
            items: {
                $ref: '#/components/schemas/NebenantragDto',
            },
        },
        size: {
            type: 'integer',
            format: 'int32',
        },
        numberOfElements: {
            type: 'integer',
            format: 'int32',
        },
        totalElements: {
            type: 'integer',
            format: 'int64',
        },
        totalPages: {
            type: 'integer',
            format: 'int32',
        },
        empty: {
            type: 'boolean',
        },
    },
} as const;

export const $HistorieDto = {
    required: ['aenderungsart', 'ansprechpartner', 'id', 'zeitstempel'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'Id of the Historie',
            format: 'int64',
            example: 1,
        },
        aenderungsart: {
            type: 'string',
            description: 'Bezeichnung of Aenderungsart of the Historie',
            example: 'Antrag angelegt',
        },
        zeitstempel: {
            type: 'string',
            description: 'Zeitstempel of the Historie',
            format: 'date-time',
            example: '2024-04-16T13:08:43.704Z',
        },
        ansprechpartner: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Ansprechpartner of the Historie',
            example: 'user1company@formular-demo.de',
        },
        kommentar: {
            maxLength: 500,
            minLength: 0,
            type: 'string',
            description: 'Kommentar of the Historie',
            example: 'test kommentar',
        },
    },
} as const;

export const $PaginatedResponseHistorieDto = {
    type: 'object',
    properties: {
        content: {
            type: 'array',
            items: {
                $ref: '#/components/schemas/HistorieDto',
            },
        },
        size: {
            type: 'integer',
            format: 'int32',
        },
        numberOfElements: {
            type: 'integer',
            format: 'int32',
        },
        totalElements: {
            type: 'integer',
            format: 'int64',
        },
        totalPages: {
            type: 'integer',
            format: 'int32',
        },
        empty: {
            type: 'boolean',
        },
    },
} as const;

export const $FoerderbereichDto = {
    required: ['bezeichnung', 'id', 'sortierPosition'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'ID of the Foerderbereich',
            format: 'int64',
            example: 1,
        },
        bezeichnung: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of the Foerderbereich',
            example: 'Kinoförderung',
        },
        sortierPosition: {
            type: 'integer',
            description: 'Sort position of the Foerderbereich',
            format: 'int32',
            example: 1000,
        },
    },
} as const;

export const $FoerderartDto = {
    required: ['bezeichnung', 'foerderbereichBezeichnung', 'gatewayShortname', 'id', 'rechtsgrundlage', 'sortierPosition'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'Id of the Foerderart',
            format: 'int64',
            example: 1,
        },
        bezeichnung: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of the Foerderart',
            example: 'Kinoreferenzförderung',
        },
        rechtsgrundlage: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Rechtsgrundlage of the Foerderart',
            example: 'Filmförderungsgesetz (FFG): §§ 138 - 144 FFG',
        },
        foerderbereichBezeichnung: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of the Foerderbereich of the Foerderart',
            example: 'Kinoförderung',
        },
        gueltigBis: {
            type: 'string',
            description: 'Date when the Foerderart can not be submitted anymore',
            format: 'date-time',
            example: '2022-12-31T23:59:59.123Z',
        },
        gatewayShortname: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Gateway shortname of the Foerderart',
            example: 'ki-ref',
        },
        sortierPosition: {
            type: 'integer',
            description: 'Sort position of the Foerderbereich',
            format: 'int32',
            example: 1000,
        },
    },
} as const;

export const $FoerderantragDto = {
    required: [
        'aktualisiertAm',
        'aktualisiertVon',
        'antragsnummer',
        'antragsteller',
        'foerderartAktiv',
        'foerderartBezeichnung',
        'id',
        'projektname',
        'status',
    ],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'Id of the Foerderantrag',
            format: 'int64',
            example: 1,
        },
        status: {
            type: 'string',
            description: 'Status of the Foerderantrag',
            example: 'ANTRAG_ANGELEGT',
            enum: [
                'ANTRAG_ANGELEGT',
                'ANTRAG_EINGEREICHT',
                'PRUEFUNG',
                'PRUEFUNG_ERNEUT',
                'ANTRAG_ZURUECKGEZOGEN',
                'ANTRAG_DATENNACHFORDERUNG',
                'KOMMISSION',
                'KOMMISSION_DATENNACHREICHUNG',
                'ABLEHNUNG',
                'ZUSAGE_PRUEFUNG',
                'ANTRAG_BEWILLIGT',
                'VERWENDUNGSNACHWEISPRUEFUNG',
                'WIDERSPRUCH',
                'TILGUNG',
                'ABGESCHLOSSEN',
                'DATENUEBERNAHME',
                'DATENUEBERNAHME_ABGESCHLOSSEN',
                'WIRD_EINGEREICHT',
                'ABHOLBEREIT',
                'ABGEHOLT',
                'ANTRAG_GELOESCHT',
            ],
        },
        antragsteller: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Antragsteller of the Foerderantrag',
            example: 'user1company@formular-demo.de',
        },
        gatewayId: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Gateway Id of the Foerderantrag',
            example: '1234',
        },
        formularShortname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Formularshortname of the Foerderantrag',
            example: 'FFA_000',
        },
        fmsUuid: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'FMS uuid of the Foerderantrag',
            example: '1136b543-5bf4-49d2-9ed8-aadad4256cd5',
        },
        antragsnummer: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Antragsnummer of the Foerderantrag',
            example: '567-2',
        },
        foerdernummer: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Foerdernummer of the Foerderantrag',
            example: '45789',
        },
        aktualisiertAm: {
            type: 'string',
            description: 'Date of the last update of the Foerderantrag',
            format: 'date-time',
            example: '2024-04-16T13:08:43.704Z',
        },
        eingereichtAm: {
            type: 'string',
            description: 'Date when the Foerderantrag was eingereicht',
            format: 'date-time',
            example: '2024-04-16T13:08:43.704Z',
        },
        aktualisiertVon: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'E-Mail of Nutzer who did the last update of the Foerderantrag',
            example: 'user4company@formular-demo.de',
        },
        foerderartBezeichnung: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of Foerderart of the Foerderantrag',
            example: 'Projektfilmförderung',
        },
        foerderartAktiv: {
            type: 'boolean',
            description: 'Bool if the foerderart is still akitv',
            example: true,
        },
        foerderartGueltigBis: {
            type: 'string',
            description: 'Date when the Foerderart can not be submitted anymore',
            format: 'date-time',
            example: '2022-12-31T23:59:59.123Z',
        },
        projektname: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Projektname of the Foerderantrag',
            example: 'Umbau von Kino 1',
        },
        fristFreischaltung: {
            type: 'string',
            description: 'Timestamp when the antrag can be edited',
            example: '2024-04-16T13:08:43.704Z',
        },
        fristEnde: {
            type: 'string',
            description: 'Timestamp when the antrag has to be submitted again',
            format: 'date-time',
            example: '2024-04-16T13:08:43.704Z',
        },
        hasPendingWiderspruch: {
            type: 'boolean',
            description: 'Bool if there is an Widerruf Nebenantrag, that is submitted but not finished ',
            example: true,
        },
        hasPendingRuecknahme: {
            type: 'boolean',
            description: 'Bool if there is an Zurueckziehen Nebenantrag, that is submitted but not finished ',
            example: true,
        },
        hasAntragPdf: {
            type: 'boolean',
            description: 'Bool if there is an form.pdf in the DB',
            example: true,
        },
    },
} as const;

export const $PaginatedResponseFoerderantragDto = {
    type: 'object',
    properties: {
        content: {
            type: 'array',
            items: {
                $ref: '#/components/schemas/FoerderantragDto',
            },
        },
        size: {
            type: 'integer',
            format: 'int32',
        },
        numberOfElements: {
            type: 'integer',
            format: 'int32',
        },
        totalElements: {
            type: 'integer',
            format: 'int64',
        },
        totalPages: {
            type: 'integer',
            format: 'int32',
        },
        empty: {
            type: 'boolean',
        },
    },
} as const;

export const $DokumentContentDto = {
    required: ['content', 'dokumentId', 'filename'],
    type: 'object',
    properties: {
        filename: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Name of the Dokument',
            example: 'Kostennachweis.pdf',
        },
        dokumentId: {
            type: 'integer',
            description: 'Id of the Dokument',
            format: 'int64',
            example: 1,
        },
        content: {
            type: 'string',
            description: 'Content of the document',
            format: 'byte',
        },
    },
} as const;

export const $AntragsDokumentDto = {
    required: ['antragAntragsnummer', 'content', 'dateityp', 'name', 'tagType'],
    type: 'object',
    properties: {
        antragAntragsnummer: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Antragsnummer of the Foerderantrag',
            example: 'REG-F1_D5-2406-FHEODS',
        },
        name: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Name of the Dokument',
            example: 'form.pdf',
        },
        dateityp: {
            maxLength: 255,
            minLength: 0,
            type: 'string',
            description: 'Dateityp of the Dokument',
            example: 'pdf',
        },
        tagType: {
            type: 'string',
            description: 'TagType of the Dokument',
            example: 'FORM_PDF',
            enum: [
                'FORM_JSON',
                'FORM_PDF',
                'FORM_XML',
                'FORM_JSON_OLD',
                'FORM_PDF_OLD',
                'FORM_XML_OLD',
                'FORM_REOPEN_XML',
                'ATTACHMENT',
                'FFA_DOCUMENT',
                'FFA_BESCHEID',
                'PORTAL_RECHTLICHES',
                'MALWARE_INFO',
                'ERROR_INFO',
                'DELETABLE',
            ],
        },
        content: {
            type: 'string',
            description: 'Byte content of the Dokument',
            format: 'byte',
        },
    },
} as const;

export const $RequiredLesebestaetigungDto = {
    required: ['dokumentname', 'projektname'],
    type: 'object',
    properties: {
        dokumentname: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Name of the Dokument',
            example: 'Bewilligungsbescheid der Förderung des Hauptantrags',
        },
        projektname: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Projektname of the Foerderantrag',
            example: 'Umbau von Kino 1',
        },
    },
} as const;

export const $FfaDokumentDto = {
    required: ['antragsnummer', 'datum', 'id', 'name', 'type'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'Id of the Dokument',
            format: 'int64',
            example: 1,
        },
        name: {
            type: 'string',
            description: 'Name of the Dokument',
            example: 'Bewilligungsbescheid der Förderung des Hauptantrags',
        },
        antragsnummer: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Antragsnummer of the Foerderantrag',
            example: 'FFA_123-123456',
        },
        type: {
            type: 'string',
            description: 'TagType of the Dokument',
            example: 'FFA_DOKUMENT',
            enum: [
                'FORM_JSON',
                'FORM_PDF',
                'FORM_XML',
                'FORM_JSON_OLD',
                'FORM_PDF_OLD',
                'FORM_XML_OLD',
                'FORM_REOPEN_XML',
                'ATTACHMENT',
                'FFA_DOCUMENT',
                'FFA_BESCHEID',
                'PORTAL_RECHTLICHES',
                'MALWARE_INFO',
                'ERROR_INFO',
                'DELETABLE',
            ],
        },
        datum: {
            type: 'string',
            description: 'Date of receiving the Dokument',
            format: 'date-time',
            example: '2024-04-16T13:08:43.704Z',
        },
        gelesen: {
            type: 'boolean',
            description: 'Whether the Dokument is read',
            example: true,
        },
    },
} as const;

export const $PaginatedResponseFfaDokumentDto = {
    type: 'object',
    properties: {
        content: {
            type: 'array',
            items: {
                $ref: '#/components/schemas/FfaDokumentDto',
            },
        },
        size: {
            type: 'integer',
            format: 'int32',
        },
        numberOfElements: {
            type: 'integer',
            format: 'int32',
        },
        totalElements: {
            type: 'integer',
            format: 'int64',
        },
        totalPages: {
            type: 'integer',
            format: 'int32',
        },
        empty: {
            type: 'boolean',
        },
    },
} as const;

export const $UnternehmenSelectionDto = {
    required: ['unternehmenAktiv', 'unternehmenId', 'unternehmenName'],
    type: 'object',
    properties: {
        unternehmenId: {
            type: 'integer',
            description: 'ID of the unternehmen',
            format: 'int64',
            example: 1,
        },
        unternehmenName: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Name of the unternehmen',
            example: 'Testunternehmen',
        },
        unternehmenAktiv: {
            type: 'boolean',
            description: 'Whether the unternehmen is currently active',
            example: true,
        },
    },
} as const;

export const $FileContentDto = {
    required: ['content', 'filename'],
    type: 'object',
    properties: {
        content: {
            type: 'string',
            description: 'The content of the file as binary',
            format: 'byte',
            example: 'ZmlsZSBiaW5hcnkgY29udGVudA==',
        },
        filename: {
            type: 'string',
            description: 'The name of the file',
            example: 'file.pdf',
        },
    },
} as const;

export const $RenderedTemplateDto = {
    required: ['htmlContent'],
    type: 'object',
    properties: {
        htmlContent: {
            type: 'string',
            description: 'The rendered Thymeleaf template as html',
            example: '<main>...</main>',
        },
    },
} as const;

export const $MaintenanceDto = {
    type: 'object',
    properties: {
        start: {
            type: 'string',
            description: 'Start time of the maintenance',
            format: 'date-time',
            example: '2025-01-01T00:00:00Z',
        },
        end: {
            type: 'string',
            description: 'End time of the maintenance',
            format: 'date-time',
            example: '2025-01-01T00:00:00Z',
        },
    },
} as const;

export const $PaginatedResponsePostkorbNachrichtDto = {
    type: 'object',
    properties: {
        content: {
            type: 'array',
            items: {
                $ref: '#/components/schemas/PostkorbNachrichtDto',
            },
        },
        size: {
            type: 'integer',
            format: 'int32',
        },
        numberOfElements: {
            type: 'integer',
            format: 'int32',
        },
        totalElements: {
            type: 'integer',
            format: 'int64',
        },
        totalPages: {
            type: 'integer',
            format: 'int32',
        },
        empty: {
            type: 'boolean',
        },
    },
} as const;

export const $PostkorbNachrichtDto = {
    required: ['id', 'zustellzeitpunkt'],
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            description: 'Id of the Postkorbnachricht',
            format: 'int64',
            example: 1,
        },
        betreff: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'Betreff of the Postkorbnachricht',
            example: 'Betreff',
        },
        nachricht: {
            maxLength: 1000,
            minLength: 0,
            type: 'string',
            description: 'Nachricht of the Postkorbnachricht',
            example: 'Nachricht',
        },
        zustellzeitpunkt: {
            type: 'string',
            description: 'Zustellzeitpunkt of the Postkorbnachricht',
            format: 'date-time',
        },
        gelesen: {
            type: 'boolean',
            description: 'Lesebstätigung of the Postkorbnachricht',
            example: true,
        },
        mitAnhang: {
            type: 'boolean',
            description: 'Whether the Postkorbnachricht has attachments',
            example: false,
        },
        mitEmpfangsbestaetigung: {
            type: 'boolean',
            description: 'Whether the Postkorbnachricht has a Empfangsbestaetigung',
            example: false,
        },
        projektname: {
            type: 'string',
            description: 'Projektname of the referenced Foerderantrag',
            example: 'Umbau von Kino 1',
        },
        antragsnummer: {
            type: 'string',
            description: 'Antragsnummer of the referenced Foerderantrag',
            example: '567-2',
        },
    },
} as const;

export const $FormContentDto = {
    type: 'object',
    properties: {
        formContent: {
            type: 'array',
            description: 'List of form fields',
            items: {
                $ref: '#/components/schemas/FormFieldDto',
            },
        },
    },
    description: 'DTO representing the content of a form',
} as const;

export const $FormFieldDto = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            description: 'ID of the form field',
            example: 'field1',
        },
        value: {
            type: 'string',
            description: 'Value of the form field',
            example: 'example value',
        },
        type: {
            type: 'string',
            description: 'Type of the form field',
            example: 'text',
        },
        readonly: {
            type: 'boolean',
            description: 'Readonly status of the form field',
            example: true,
        },
        hId: {
            type: 'string',
            description: 'Id of the multivalue field group',
            example: '1',
        },
        hGroupId: {
            type: 'string',
            description: 'Name of the multivalue field groups',
            example: 'bol.dlgInputs.Niederlassung',
        },
    },
    description: 'DTO representing a form field',
} as const;

export const $DokumentMappingDto = {
    required: ['antragAntragsnummer', 'formFieldId', 'name', 'nscaleId'],
    type: 'object',
    properties: {
        antragAntragsnummer: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Antragsnummer of the Foerderantrag',
            example: 'REG-F1_D5-2406-FHEODS',
        },
        name: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Name of the Dokument in the json file',
            example: 'Kostennachweis.pdf',
        },
        nscaleId: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'NscaleId of the Dokument',
            example: 'ffa$843056$NOTSET$2$NOTSET',
        },
        formFieldId: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'FormFieldId of the Dokument',
            example: 'Auswertung.Kino.Kostennachweis',
        },
    },
} as const;

export const $AntragDto = {
    required: ['antragsartBezeichnung', 'antragsartShortname', 'antragsnummer', 'eingereichtAm'],
    type: 'object',
    properties: {
        antragsnummer: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Antragsnummer of the Antrag',
            example: 'REG-F1_D5-2406-FHEODS',
        },
        eingereichtAm: {
            type: 'string',
            description: 'DateTime the Antrag was submitted',
            format: 'date-time',
        },
        antragsartBezeichnung: {
            maxLength: 200,
            minLength: 0,
            type: 'string',
            description: 'Bezeichnung of Foerderart/Nebenantragsart of the Antrag',
            example: 'Projektfilmförderung',
        },
        antragsartShortname: {
            maxLength: 100,
            minLength: 0,
            type: 'string',
            description: 'GatewayShortname of Foerderart/Nebenantragsart of the Antrag',
            example: 'pro-fi',
        },
        hauptantragAntragsnummer: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'Antragsnummer of the Hauptantrag of the Nebenantrag; Empty if it is a Foerderantrag',
            example: 'REG-F1_D5-2406-FHEODS',
        },
        isHauptantrag: {
            type: 'boolean',
            description: 'Whether the Antrag is a Foerderantrag or Nebenantrag',
            example: true,
        },
        isAenderung: {
            type: 'boolean',
            description: 'Whether the Antrag is the first submission or a follow-up. Also set to true for any Stammdatenaktualisierung',
            example: true,
        },
    },
} as const;

export const $PlatzhalterantragStatusDto = {
    required: ['nscaleId'],
    type: 'object',
    properties: {
        nscaleId: {
            maxLength: 50,
            minLength: 0,
            type: 'string',
            description: 'NscaleId of the Antrag',
            example: 'ffa$843056$NOTSET$2$NOTSET',
        },
        transferred: {
            type: 'boolean',
            description: 'Whether the Antrag was transferred',
            example: true,
        },
    },
} as const;
